
export const hook = ((_block, _unblock) => {
  block = _block
  unblock = _unblock
}) as never

export const unhook = (() => {
  block = () => {}
  unblock = () => {}
}) as never

let block
let unblock

(unhook as any)();

let token = 0
export function BlockUI(msg: string): number {
  token++;
  block(msg, token)
  return token
}

export function UnBlockUI(token: number) {
  unblock(token)
}